"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const MapSideBarNavigation_vue_1 = __importDefault(require("./MapSideBarNavigation.vue"));
const MapSideBarPanelProjects_vue_1 = __importDefault(require("./MapSideBarPanelProjects.vue"));
const MapSideBarPanelProducts_vue_1 = __importDefault(require("./MapSideBarPanelProducts.vue"));
const MapSideBarPanelMetrics_vue_1 = __importDefault(require("./MapSideBarPanelMetrics.vue"));
const MapSideBarPanelTools_vue_1 = __importDefault(require("./MapSideBarPanelTools.vue"));
const MapSideBarPanelActions_vue_1 = __importDefault(require("./MapSideBarPanelActions.vue"));
const MapSideBarPanelRecommendations_vue_1 = __importDefault(require("./MapSideBarPanelRecommendations.vue"));
const MapSideBarPanelAgronomicInsights_vue_1 = __importDefault(require("./MapSideBarPanelAgronomicInsights.vue"));
const MapSideBarPanelNeedMaps_vue_1 = __importDefault(require("./MapSideBarPanelNeedMaps.vue"));
const NeedMap_1 = require("@becrop/abstract/Models/NeedMap");
const MapSideBarPanelFarms_vue_1 = __importDefault(require("./MapSideBarPanelFarms.vue"));
const MapSideBarPanelNeedMapsScaffold_vue_1 = __importDefault(require("./MapSideBarPanelNeedMapsScaffold.vue"));
const MapSideBarPanelMetricsScaffold_vue_1 = __importDefault(require("./MapSideBarPanelMetricsScaffold.vue"));
let MapSideBar = class MapSideBar extends vue_property_decorator_1.Vue {
    updateFieldActiveKey(f) {
        this.$emit('updateFieldActiveKey', f);
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    selectFarm(farm) {
        this.$emit('selectFarm', farm);
    }
    /*     @Watch('enableNeedMaps')
        changePanelByFlag() {
            if (this.enableNeedMaps) {
                this.setActivePanel('need-maps')
            } else {
                this.setActivePanel('')
            }
        }
    
        @Watch('activePanel')
        emitActivePanel() {
            this.$emit('activePanel', this.activePanel);
        } */
    fetchFarms() {
        this.$emit('fetchFarms');
    }
    setActivePanel(value) {
        this.$emit('activePanel', value);
    }
    downloadReport() {
        this.$emit('downloadReport', true);
    }
    updateMainProject(p) {
        this.$emit('updateMainProject', p);
    }
    updateSecondaryProject(p) {
        this.$emit('updateSecondaryProject', p);
    }
    updateMetric(m) {
        this.$emit('updateMetric', m);
    }
    updatePhChMetric(m) {
        this.$emit('updatePhChMetric', m);
    }
    updateComparisonMetric(m, p) {
        this.$emit('updateComparisonMetric', m, p);
    }
    updatePhChComparisonMetric(m, p) {
        this.$emit('updatePhChComparisonMetric', m, p);
    }
    updateNeedMap(needMap) {
        this.$emit('updateNeedMap', needMap);
    }
    toggleRecommendations(show) {
        this.$emit('onToggleRecommendations', show);
    }
    deployDoblePanel() {
        this.$emit('deployDoblePanel');
    }
    changePanel(p) {
        /*         if (this.activePanel === p) {
                    this.activePanel = '';
                } else {
                    this.activePanel = p;
                } */
        if (p === 'home') {
            window.location.href = '/dashboard';
        }
        if (p === 'back') {
            window.location.href = '/results/projects';
        }
        this.$emit('changePanel', p);
    }
    switchDimension(k) {
        this.$emit('switchDimension', k);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null })
], MapSideBar.prototype, "areaProjectMapController", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], MapSideBar.prototype, "enableNeedMaps", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: (Array), default: [] })
], MapSideBar.prototype, "mainProjectsList", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: (Array), default: [] })
], MapSideBar.prototype, "secondaryProjectsList", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: (Array), default: [] })
], MapSideBar.prototype, "compositableProjects", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBar.prototype, "mainProject", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBar.prototype, "secondaryProject", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBar.prototype, "mainProjectDelivery", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBar.prototype, "comparisonReport", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBar.prototype, "metricComparison", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBar.prototype, "metricPhChComparison", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBar.prototype, "metric", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBar.prototype, "metricAgInsights", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBar.prototype, "phchMetric", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBar.prototype, "loadingDetailStatus", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'single' })
], MapSideBar.prototype, "mode", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'bio' })
], MapSideBar.prototype, "dimension", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], MapSideBar.prototype, "entityType", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], MapSideBar.prototype, "activePanel", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], MapSideBar.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBar.prototype, "secondarySingleProjectDelivery", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBar.prototype, "currentSubclient", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], MapSideBar.prototype, "isBiome", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], MapSideBar.prototype, "isBmk", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], MapSideBar.prototype, "isRendering", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBar.prototype, "agronomicInsight", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], MapSideBar.prototype, "zeroViewMessage", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], MapSideBar.prototype, "zeroViewIcon", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], MapSideBar.prototype, "polygonSelectedItem", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: new NeedMap_1.NeedMap({}) })
], MapSideBar.prototype, "currentNeedMap", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], MapSideBar.prototype, "fieldActiveKey", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: [] })
], MapSideBar.prototype, "farms", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false })
], MapSideBar.prototype, "isLoadingFetchFarms", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null })
], MapSideBar.prototype, "currentFarm", void 0);
MapSideBar = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            MapSideBarNavigation: MapSideBarNavigation_vue_1.default,
            MapSideBarPanelProjects: MapSideBarPanelProjects_vue_1.default,
            MapSideBarPanelMetrics: MapSideBarPanelMetrics_vue_1.default,
            MapSideBarPanelMetricsScaffold: MapSideBarPanelMetricsScaffold_vue_1.default,
            MapSideBarPanelTools: MapSideBarPanelTools_vue_1.default,
            MapSideBarPanelActions: MapSideBarPanelActions_vue_1.default,
            MapSideBarPanelRecommendations: MapSideBarPanelRecommendations_vue_1.default,
            MapSideBarPanelAgronomicInsights: MapSideBarPanelAgronomicInsights_vue_1.default,
            MapSideBarPanelNeedMaps: MapSideBarPanelNeedMaps_vue_1.default,
            MapSideBarPanelNeedMapsScaffold: MapSideBarPanelNeedMapsScaffold_vue_1.default,
            MapSideBarPanelFarms: MapSideBarPanelFarms_vue_1.default,
            MapSideBarPanelProducts: MapSideBarPanelProducts_vue_1.default
        },
    })
], MapSideBar);
exports.default = MapSideBar;
